import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ngx-relations-graph',
  templateUrl: './relations-graph.component.html',
  styleUrls: ['./relations-graph.component.scss']
})
export class RelationsGraphComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
